<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="12" md="auto">
        <BaseBreadcrumbs :crumbs="crumbs" class="px-0 py-0"/> 
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" md="6">
        <v-chip
          @click="getSpecialProduct('tree')"
          class="mr-2"
          :color="treeActive ? 'primary' : ''"
          :text-color="treeActive ? 'white' : ''"
        >
          <v-icon v-if="treeActive" left>
            mdi-corn
          </v-icon>
          Đặc sản trồng trọt
        </v-chip>
        <v-chip
          @click="getSpecialProduct('animal')"
          class="mr-2"
          :color="animalActive ? 'primary' : ''"
          :text-color="animalActive ? 'white' : ''"
        >
          <v-icon v-if="animalActive" left>
            mdi-cow
          </v-icon>
          Đặc sản chăn nuôi
        </v-chip>
      </v-col>
      <v-col cols="12" md="6">
        <h4 class="text-right font-weight-light">
          Trang {{currentPage}} (Tổng {{totalPages}} Trang, {{totalItems}} mặt hàng)
        </h4>
      </v-col>
    </v-row>
    <v-row v-if="treeActive">
      <v-col 
        v-for="(product, index) in tree_items" 
        :key="index" 
        cols="12"
        sm="6"
        md="3"
      >
        <v-sheet height="100%" class="rounded-lg overflow-hidden">
          <v-hover
            v-slot="{ hover }"
          >
            <v-card flat>
              <router-link
                :to="{ name: 'TreeProductTrace', params: { id: product.id }}"
              >
                <v-img
                  v-if="product.hinhAnhBase64"
                  :src="product.hinhAnhBase64"
                  :style="{opacity: hover ? '0.3' : 1}"
                  :class="hover ? 'zoom' : ''"
                  :aspect-ratio="16/9"
                />
                <v-img
                  v-else
                  src="@/assets/dac-san-logo.jpg"
                  :style="{opacity: hover ? '0.3' : 1}"
                  :class="hover ? 'zoom' : ''"
                  :aspect-ratio="16/9"
                />
              </router-link>
              <v-card-title>
                <router-link
                  :to="{ name: 'TreeProductTrace', params: { id: product.id }}"
                  class="black--text text-body-2 font-weight-bold"
                >
                  {{product.tenCayTrong}}
                </router-link>
                <v-spacer/>
                <span class="text-body-2 font-italic">
                  <v-icon small>mdi-eye</v-icon>
                  {{ product.countview || 1 }}
                </span>
              </v-card-title>
              <v-card-subtitle>Mùa vụ: 
                <span v-html="formatMuaVu(product.muaVu)"/>
              </v-card-subtitle>
            </v-card>
          </v-hover>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col 
        v-for="(product, index) in animal_items" 
        :key="index" 
        cols="12"
        sm="6"
        md="3"
      >
        <v-sheet class="rounded-lg overflow-hidden">
          <v-hover
            v-slot="{ hover }"
          >
            <v-card flat>
              <router-link
                :to="{ name: 'AnimalProductTrace', params: { id: product.id }}"
              >
                <v-img
                  v-if="product.hinhVatNuoi"
                  :src="`${config.agriDataBackUrl}/file-download/file/${product.hinhVatNuoi.filename}`"
                  :style="{opacity: hover ? '0.3' : 1}"
                  :class="hover ? 'zoom' : ''"
                  :aspect-ratio="16/9"
                />
                <v-img
                  v-else
                  src="@/assets/dac-san-chan-nuoi-logo.jpg"
                  :style="{opacity: hover ? '0.3' : 1}"
                  :class="hover ? 'zoom' : ''"
                  :aspect-ratio="16/9"
                />
              </router-link>
              <v-card-title>
                <router-link
                  :to="{ name: 'AnimalProductTrace', params: { id: product.id }}"
                  class="black--text text-body-2 font-weight-bold"
                >
                  {{product.ten}}
                </router-link>
                <v-spacer/>
                <span class="text-body-2 font-italic">
                  <v-icon small>mdi-eye</v-icon>
                  {{ product.countview || 1 }}
                </span>
              </v-card-title>
              <v-card-subtitle>Thuộc loài: 
                <span v-if="product.loaiDongVat">
                  {{product.loaiDongVat.tenLoaiDongVat}}
                </span>
              </v-card-subtitle>
            </v-card>
          </v-hover>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="text-center">
          <v-pagination
            v-if="totalPages > 1"
            v-model="currentPage"
            :length="totalPages"
            @input="handlePageChange"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import { mapGetters, mapState, mapActions } from 'vuex';
  import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs';
  export default {
    components: { 
      BaseBreadcrumbs
    },
    data: () => ({
      loading: false,
      crumbs: [],
      currentPage: 1,
      totalItems: 0,
      totalPages: 0,
      tree_items: [],
      animal_items: [],
      selectedOrderItem: null,
      orders:[
        {
          action: 'mdi-order-alphabetical-ascending', 
          value: 'tieu_de', 
          text: 'Tên hàng hóa'
        },
        {
          action: 'mdi-order-numeric-ascending', 
          value: 'gia_ban', 
          text: 'Giá bán'
        },
        {
          action: 'mdi-order-numeric-ascending', 
          value: 'created_at', 
          text: 'Ngày đăng'
        }
      ],
      sorts: [
        {value: 'asc', text: 'A-Z'},
        {value: 'desc', text: 'Z-A'}
      ],
      treeActive: false,
      animalActive: false,
    }),
    watch: {
      "$route.params.type": function(val) {
        if(val == 'animal'){
          this.getAnimalSpecialProduct();
        } else {
          this.getTreeSpecialProduct();
        }
        this.currentPage = 1;
        this.totalPages = 0;
        this.tree_items = [];
        this.animal_items = [];
      }
    },
    mounted () {
      if(this.$route.params.type == 'animal'){
        this.getAnimalSpecialProduct();
      } else {
        this.getTreeSpecialProduct();
      }
      this.crumbs = [
        {
          text: 'Trang chủ',
          disabled: false,
          href: '/',
        },
        {
          text: 'Nhóm sản phẩm',
          disabled: false,
          href: '/products',
        },
        {
          text: 'Sản phẩm đặc sản',
          disabled: true
        }
      ];
    },
    computed: {
      ...mapGetters([
        'isLogged'
      ]),
      ...mapState([
        'config'
      ])
    },
    methods: {
      ...mapActions([
        'getLoader'
      ]),
      getRequestParams(page) {
        let params = {};

        if (page) {
          params["page"] = page;
        }
        
        return params;
      },
      handlePageChange(value) {
        this.currentPage = value;
        if(this.$route.params.type == 'animal') {
          this.getAnimalSpecialProduct();
        } else {
          this.getTreeSpecialProduct();
        }
        this.$vuetify.goTo(0);
      },
      getSpecialProduct(type){
        this.$router.push({
          name:'SpecialProduct',
          params:{type:type}
        });
      },
      getTreeSpecialProduct () {
        const app = this;
        const params = app.getRequestParams(
          app.currentPage,
        );
        app.treeActive = false;
        app.animalActive = false;
        app.getLoader(true);
        let request = {
          params: params
        };
        axios.get("api/v1/public/get-tree-special-product", request)
          .then(response => {
            app.tree_items = response.data.data;
            app.totalItems = response.data.total;
            const caluTotalPage = response.data.total/response.data.per_page;
            app.totalPages = Math.ceil(caluTotalPage);
            app.treeActive = true;
            app.getLoader(false);
          })
          .catch(function (error) {
            console.log(error);
            app.getLoader(false);
          });
      },
      getAnimalSpecialProduct () {
        const app = this;
        const params = app.getRequestParams(
          app.currentPage,
        );
        app.treeActive = false;
        app.animalActive = false;
        app.getLoader(true);
        let request = {
          params: params
        };
        axios.get("api/v1/public/get-animal-special-product", request)
          .then(response => {
            app.animal_items = response.data.data;
            app.totalItems = response.data.total;
            const caluTotalPage = response.data.total/response.data.per_page;
            app.totalPages = Math.ceil(caluTotalPage);
            app.animalActive = true;
            app.getLoader(false);
          })
          .catch(function (error) {
            console.log(error);
            app.getLoader(false);
          });
      },
      formatMuaVu(mv) {
        if(!mv) return mv;
        let mv_array = mv.split(';');
        if(mv_array.length > 0){
          return mv_array.join('<br>');
        }
        return mv;
      }
    }
  }
</script>
<style>
  .qrcode{
    border: 1px solid #79ce09;
    padding: 5px;
    cursor: zoom-in;
    position: absolute;
    right: 5px;
    top: 5px;
  }
  .v-card__actions.productInfo{
    text-overflow: ellipsis;
    height: 56px;
  }
  .v-image .v-image__image {
    transition: all 0.2s;
  }
  .v-image.zoom .v-image__image {
    transform: scale(1.2);
  }
  .v-card__text, .v-card__title {
    word-break: normal;
  }
</style>